'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

// Components


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _UserAvatar = require('../../../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _AccountPopup = require('./AccountPopup');

var _AccountPopup2 = _interopRequireDefault(_AccountPopup);

var _BillingAlertPopup = require('./BillingAlertPopup');

var _BillingAlertPopup2 = _interopRequireDefault(_BillingAlertPopup);

var _ElectronAppUpdateNotify = require('./electronApp/ElectronAppUpdateNotify');

var _ElectronAppUpdateNotify2 = _interopRequireDefault(_ElectronAppUpdateNotify);

var _popupActions = require('../../../../components/popupPanel/popupActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            return dispatch((0, _popupActions.togglePopup)('user'));
        }
    };
};

var AccountUtil = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _recompose.onlyUpdateForKeys)(['currentUser']), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(AccountUtil, _React$Component);

    function AccountUtil() {
        _classCallCheck(this, AccountUtil);

        return _possibleConstructorReturn(this, (AccountUtil.__proto__ || Object.getPrototypeOf(AccountUtil)).apply(this, arguments));
    }

    _createClass(AccountUtil, [{
        key: 'render',
        value: function render() {
            var currentUser = this.props.currentUser;


            return _react2.default.createElement(
                'div',
                { className: 'HeaderUtil' },
                _react2.default.createElement(
                    _Button2.default,
                    { className: 'highlight', onClickFn: this.props.openPopupPanel },
                    _react2.default.createElement(_UserAvatar2.default, { user: currentUser }),
                    _react2.default.createElement(_ElectronAppUpdateNotify2.default, null)
                ),
                _react2.default.createElement(_AccountPopup2.default, null),
                _react2.default.createElement(_BillingAlertPopup2.default, null)
            );
        }
    }]);

    return AccountUtil;
}(_react2.default.Component)) || _class) || _class);


AccountUtil.propTypes = {
    currentUser: _propTypes2.default.object,
    openPopupPanel: _propTypes2.default.func
};

exports.default = AccountUtil;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/AccountUtil.js
// module id = 2169
// module chunks = 0